import { RefObject, useEffect } from "react";

/**
 * Закрытие поповера: Escape и клик/тап снаружи. При закрытии по Escape
 * фокус возвращается на триггер.
 */
export function useDismiss(
  open: boolean,
  onClose: () => void,
  containerRef: RefObject<HTMLElement>,
  triggerRef?: RefObject<HTMLElement>,
) {
  useEffect(() => {
    if (!open) return;
    function key(e: KeyboardEvent) {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
        triggerRef?.current?.focus();
      }
    }
    function pointer(e: MouseEvent | TouchEvent) {
      const target = e.target as Node | null;
      if (containerRef.current && target && !containerRef.current.contains(target))
        onClose();
    }
    document.addEventListener("keydown", key);
    document.addEventListener("mousedown", pointer);
    document.addEventListener("touchstart", pointer);
    return () => {
      document.removeEventListener("keydown", key);
      document.removeEventListener("mousedown", pointer);
      document.removeEventListener("touchstart", pointer);
    };
  }, [open, onClose, containerRef, triggerRef]);
}
